{
    "header": {},
    "footer": {},
    "page": {
        "select-device": {
            "fluidnc": "如果您想要安装、升级或配置您的 Arabesque 控制器，请使用此选项。",
            "continue": "点击继续"
        },
        "connection": {
            "title": "Arabesque 在线安装配置引导",
            "description": "此工具将易于在设备上安装或升级 Arabesque 。请将设备连接并按 Connect 继续。",
            "connect": "连接",
            "connecting": "连接中",
            "establishing-connection": "建立到控制器的连接"
        },
        "home": {
            "description": "您已连接到设备，请可以进行下面的操作",
            "error-while-booting": "启动时发生错误，可能是由于配置无效。",
            "show-details": "点击这里查看详情"
        },
        "file-browser": {
            "title": "内置文件",
            "loading": "加载中",
            "downloading": "下载中",
            "uploading": "上传中",
            "config-missing": "缺少配置文件“{{configFilename}}”，是否要创建它？",
            "create-config": "创建配置",
            "create-new-config": "创建新配置",
            "upload": "上传",
            "active-config": "当前配置",
            "select-config": "选择配置文件",
            "select-as-config": "选择为配置文件",
            "edit": "编辑",
            "delete": "删除",
            "download": "下载"
        },
        "terminal": {
            "title": "终端",
            "restarting": "重新启动设备",
            "restart": "重新启动",
            "restart-description": "通过设置 DTR/RTS 在控制器上进行硬重置",
            "reset": "重置",
            "reset-description": "重置控制器为 0x18 命令",
            "unlock": "解锁",
            "unlock-description": "用$X解锁设备",
            "status": "状态",
            "status-description": "获得设备状态",
            "startup": "获得初始化设备状态",
            "startup-description": "获取初始化设备状态日志",
            "version": "版本",
            "version-description": "获取固件版本"
        },
        "not-found": {
            "title": "无法找到页面",
            "go-back-home": "返回主页"
        }
    },
    "panel": {
        "navigation": {
            "home": "归位",
            "install": "安装",
            "terminal": "终端",
            "file-browser": "内置文件",
            "wifi": "配置WiFi网络",
            "calibrate": "检查引脚",
            "stacktrace-decoder": "Decode Stack Trace",
            "restart": "重启",
            "disconnect": "断开连接"
        },
        "firmware": {
            "install": "安装",
            "install-description": "请选择你想要在控制器上安装的固件版本。",
            "loading": "加载中…",
            "install-custom-image": "安装自定义图像...",
            "show-prereleases": "显示预发布",
            "fetching": "获取中"
        },
        "progress": {
            "title": "安装中",
            "downloading": "正在下载包文件...",
            "validating": "正在校验图像...",
            "flashing": "正在安装软件包..."
        },
        "bootloader": {
            "waiting": "正在等待控制器进入bootloader",
            "not-active": "引导加载器未激活 - 请按下 BOOT 开关"
        },
        "unsupported": {
            "title": "浏览器不支持",
            "description": "您当前的浏览器不支持，请使用 Chrome、Edge 或 Opera 代替。"
        }
    },
    "component": {
        "log": {
            "show-details": "显示详情",
            "hide-details": "隐藏详情"
        }
    },
    "modal": {
        "installer": {
            "error-reconnecting": "重新连接时发生错误，请重启设备",
            "uploading": "上传中",
            "downloading": "下载中",
            "downloading-description": "正在下载包...",
            "restarting": "正在重启",
            "restarting-description": "正在等待控制器重启...",
            "uploading-files": "上传文件",
            "uploading-files-description": "上传文件中……",
            "done": "已完成",
            "done-description": "控制器已成功安装，可以开始使用。",
            "continue": "继续",
            "error": "错误!",
            "close": "关闭",
            "confirm-installation": "确认安装",
            "confirm-installation-description": "将擦除设备并安装{{release}}版本的固件",
            "not": "不",
            "installation-speed": "安装速度",
            "installation-speed-help": "一些控制器需要以较低的速度安装。如果你遇到问题，你可以尝试降低速度。",
            "install": "安装",
            "cancel": "取消",
            "select-image": "选择图像",
            "select-image-description1": "如果您手动下载了一个包，您可以从这里刷入图像。",
            "select-image-description2": "选择要刷入控制器的固件.bin 文件。",
            "select-image-button": "选择固件图像"
        },
        "lost-connection": {
            "description": "无法连接到控制器",
            "close": "关闭"
        }
    },
    "card": {
        "install": {
            "upgrade-description": "升级Arabesque 从",
            "install-description": "控制器似乎没有安装 Arabesque ，你想要安装它吗？",
            "upgrade-button": "升级 Arabesque",
            "install-button": "安装 Arabesque"
        },
        "terminal": {
            "open-terminal": "打开终端",
            "open-terminal-description": "打开一个串行终端到您的控制器"
        },
        "file-browser": {
            "open-browser": "内置文件",
            "open-browser-description": "管理控制器上的文件"
        },
        "calibrate": {
            "calibrate": "检查引脚",
            "calibrate-description": "校准控制器上的设置"
        },
        "wifi": {
            "configure": "配置 WiFi",
            "configure-description": "管理控制器WiFi设置",
            "connected-to": "连接到",
            "access-point": "接入点/无线 AP "
        },
        "stacktrace": {
            "open": "Decode Stack Trace",
            "description": "Decode ESP32 stack traces using .addrinfo files"
        }
    }
}
